import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Work } from './pages/Work';
import { CaseStudyPage } from './pages/CaseStudy';
import { Contact } from './pages/Contact';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="about" element={<About data-id="element-7" />} data-id="element-6" />
          <Route path="work" element={<Work data-id="element-9" />} data-id="element-8" />
          <Route path="work/:id" element={<CaseStudyPage data-id="element-11" />} data-id="element-10" />
          <Route path="contact" element={<Contact data-id="element-13" />} data-id="element-12" />
        </Route>
      </Routes>
    </Router>;
}